import DateUtils from "global/util/DateUtils";
import LogfileZeile from "service/logfile-service/interface/LogfileZeile";
import LogfileService from "service/logfile-service/Logfile.service";
import AutomatAction, {
  AutomatActionCallback,
  AutomatActionPayload,
} from "../interface/AutomatAction";
import AutomatDataRecord from "../interface/AutomatDataRecord";
import { registerAutomatDataStoreActions } from "../use-automat-datastore";

export const FETCH_LOGFILE_RECORDS = "FETCH_LOGFILE_RECORDS";

const configureAutomatLogfileStore = () => {
  const fetchLogfileRecords: AutomatAction = {
    identifier: FETCH_LOGFILE_RECORDS,
    action: (
      currentState: AutomatDataRecord,
      payload: AutomatActionPayload,
      callback: AutomatActionCallback,
      callbackOnFail: Function
    ) => {
      LogfileService.loadByFilters(
        `${currentState.automatenblattInformation.seriennummer}`,
        DateUtils.formatDateToAPIDateString(
          payload.logfileDateFrom,
          "dd.MM.yyyy"
        ) ?? "",
        DateUtils.formatDateToAPIDateString(
          payload.logfileDateTo,
          "dd.MM.yyyy"
        ) ?? "",
        payload.logfileKategory.map((e) => e.id).join(","),
        (logfileRecords: Array<LogfileZeile>) =>
          callback({
            logfileRecords: logfileRecords,
            viewInfo: {
              ...currentState.viewInfo,
              logfileDateFrom: payload.logfileDateFrom,
              logfileDateTo: payload.logfileDateTo,
              logfileKategory: payload.logfileKategory,
            },
          } as AutomatDataRecord),
        callbackOnFail
      );
    },
  };
  registerAutomatDataStoreActions([fetchLogfileRecords]);
};

export default configureAutomatLogfileStore;
